<template>
  <div id="historyTotal">
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="inspections"
              :options.sync="options"
              :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
              :server-items-length="options.total"
              :loading="loadTable"
              @update:page="get"
              @update:items-per-page="get"
              @update:sort-by="get"
              @update:sort-desc="get"
            >
              <template v-slot:item="props" >
                <tr>
                  <td>{{props.item.name}}</td>
                  <td>{{props.item.inspections_count}}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'historyTotal',
  data () {
    return {
      loadTable: true,
      valid: false,
      addDialog: false,
      dialog: false,
      search: '',
      pageCount: 0,
      userLogged: {
        roles: [
          {
            id: 3
          }
        ]
      },
      options: {
        page: 1,
        itemsPerPage: 15,
        total: 0
      },
      inspections: [],
    }
  },
  computed: {
    rules () {
      return this.$validationRules()
    },
    headers () {
      return [
        {
          text: this.$t('general.company'),
          value: 'name',
          sortable: true
        },
        {
          text: this.$t('inspections.count'),
          value: 'inspections_count',
          sortable: true
        }
      ]
    }
  },
  created () {
    this.get()
  },
  methods: {
    close () {
      this.dialog = false
      this.addDialog = false,
      this.editedItem = Object.assign({}, this.defaultItem)
      this.removedItem = {}
      this.$refs.form.resetValidation()
    },
    view (id) {
      this.$router.push('history/view/' + id)
    },
    get () {
      this.loadTable = true
      if (this.userLogged.roles) {
        this.$store.dispatch('inspections/getTotal', {
          event:{
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            sortKey: this.options.sortBy,
            ord: this.options.sortDesc,
            type: 'json',
            context:this,
          }
        })
      }
    }
  }
}
</script>